import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { QUERY_KEYS } from '~shared/api/query-keys';

import type { Tag } from '../modal/tag';

export const deleteTagAPI = async (fieldId: string) => {
  const resp = await baseAPI.delete<Tag>(`/tags/${fieldId}`);
  return resp.data;
};

export const useDeleteTagMutation = () => {
  return useMutation({
    mutationFn: async ({ fieldId }: { fieldId: string }) => {
      const response = await deleteTagAPI(fieldId);
      return response;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: QUERY_KEYS.TAGS,
      });
    },
  });
};
